import { render, staticRenderFns } from "./IntroEmail.vue?vue&type=template&id=4478ca54&scoped=true&"
import script from "./IntroEmail.vue?vue&type=script&lang=js&"
export * from "./IntroEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478ca54",
  null
  
)

export default component.exports